export default "__VITE_ASSET__CGNgAWks__"